import CropsPerformanceDashboard from './CropsPerformanceDashboard';

export default CropsPerformanceDashboard;
